import { render, staticRenderFns } from "./LinkList.vue?vue&type=template&id=72f9e1e6&scoped=true"
import script from "./LinkList.vue?vue&type=script&lang=js"
export * from "./LinkList.vue?vue&type=script&lang=js"
import style0 from "./LinkList.vue?vue&type=style&index=0&id=72f9e1e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9e1e6",
  null
  
)

export default component.exports